module.exports = __webpack_public_path__ + "static/media/sn.091e42c6.svg";